export default __webpack_public_path__ + "static/8-a8a9f8d89fa795b46ff88920cd70df36.jpg";